import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ChevronRight } from 'lucide-react-native';
import { useTheme } from '@/contexts/ThemeContext';

interface BreadcrumbItem {
  label: string;
  onPress?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <ChevronRight size={16} color={colors.textSecondary} style={styles.separator} />
          )}
          {item.onPress ? (
            <TouchableOpacity onPress={item.onPress} style={styles.item}>
              <Text style={[styles.text, { color: colors.primary }]}>
                {item.label}
              </Text>
            </TouchableOpacity>
          ) : (
            <View style={styles.item}>
              <Text style={[styles.text, { color: colors.textSecondary }]}>
                {item.label}
              </Text>
            </View>
          )}
        </React.Fragment>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: 'transparent',
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    fontSize: 14,
    fontFamily: 'Inter-Medium',
  },
  separator: {
    marginHorizontal: 8,
  },
}); 